export const SectionBanner = ({ id }: ISectionBanner) => {
  return (
    <div className="mt-0 overflow-hidden md:mt-[-1rem]" id={id}>
      <div className="relative h-auto md:h-[39.5rem] md:pt-0">
        <div className="relative sm:m-10">
          <div className="relative left-3 right-0 z-20 m-0 mx-auto mt-[5.5rem] p-0 py-8 md:absolute md:left-20 md:mt-0 md:translate-y-[60%] md:px-0 md:py-0 lg:right-auto lg:mx-0 lg:max-w-none">
            <h2 className="w-full max-w-[320px] break-words pr-6 text-32 font-bold text-black sm:text-40 md:max-w-[700px] lg:max-w-[900px]">
              Crédito com Segurança e Agilidade
            </h2>
            <p className="mb-8 w-full max-w-[150px] break-words pb-8 pt-4 text-16 font-semibold leading-24 text-black sm:max-w-[350px] sm:text-20 md:max-w-[300px] lg:max-w-[600px]">
              Transparência, Segurança, 100% Online!
            </p>
            <div className="flex w-full items-center justify-start gap-2">
              <a
                href="https://wa.me/553432259969"
                className="animate-grow-and-shrink bg-green-wpp-light group flex items-center rounded-3 bg-green-600 p-3 text-16 font-bold leading-24 duration-200 hover:bg-green-800 sm:text-20 "
                rel="nofollow noreferrer"
                target="_blank"
                title="Envie Mensagem agora (34) 3225-9969"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 17 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.94249 10.2004C8.57999 11.8387 10.6542 12.882 11.8883 11.6537L12.1875 11.3545C12.5867 10.9562 12.5308 10.2962 12.0675 9.97446C11.7758 9.77116 11.4625 9.55286 11.1158 9.30946C10.7575 9.05786 10.2658 9.09696 9.955 9.40536L9.6167 9.74116C9.1975 9.47536 8.7825 9.13446 8.39749 8.74946L8.39582 8.74786C8.01082 8.36282 7.66999 7.94782 7.40415 7.52865L7.73999 7.19032C8.04915 6.87949 8.08749 6.38782 7.83582 6.02949C7.59165 5.68282 7.37332 5.36949 7.17082 5.07782C6.84915 4.61532 6.18915 4.55949 5.79082 4.95782L5.49166 5.25699C4.26332 6.49115 5.30666 8.56446 6.94415 10.2029M13.8739 3.24303C12.5022 1.87053 10.6781 1.11387 8.73471 1.11304C4.7289 1.11304 1.46974 4.37053 1.4689 8.3747C1.46724 9.64886 1.8014 10.9014 2.43807 12.0056L1.40723 15.7689L5.2589 14.7589C6.32474 15.3389 7.51807 15.6431 8.73141 15.6431H8.73471C12.7389 15.6431 15.9981 12.3847 15.9997 8.38053C16.0006 6.44053 15.2456 4.61637 13.8739 3.24303Z"
                    stroke="#fff"
                  ></path>
                </svg>
                <span className="ml-3 text-white transition-all ease-linear">Solicite Agora!</span>
              </a>
            </div>
          </div>
        </div>

        <picture>
          <img
            className="relative hidden h-full w-full object-fill object-center opacity-100 md:block"
            width="1440"
            height="633"
            src="/projeto/banner.jpg"
            alt="Banner"
          />
        </picture>
        <picture>
          <img
            className="sm:object-top-right absolute top-0 block h-full w-full object-cover object-top md:hidden"
            width="390"
            height="368"
            src="/projeto/banner.jpg"
            alt="Banner"
          />
        </picture>
      </div>
    </div>
  );
};

interface ISectionBanner {
  id?: string;
}
